import { render, staticRenderFns } from "./form-local-aplicacao.vue?vue&type=template&id=471008da&"
import script from "./form-local-aplicacao.vue?vue&type=script&lang=js&"
export * from "./form-local-aplicacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports